__turbopack_context__.v({
  "optionRow": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__optionRow",
  "outOfStockTag": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__outOfStockTag",
  "productName": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__productName",
  "radioButton": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__radioButton",
  "row": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__row",
  "singleLineText": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__singleLineText",
  "spaceBetween": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__spaceBetween",
  "titleRow": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__titleRow",
  "warningText": "CheckoutOutOfStockFormItem-module-scss-module__SstJiW__warningText",
});
